export default class PageTop {
  constructor() {
    this.pageTop = document.querySelector(".pageTop");
    this.footer = document.querySelector(".l-footer");
    
    if (!this.pageTop) return;

    this.init();
  }

  init() {
    this.onScroll = this.onScroll.bind(this);
    
    // スクロールイベントとリサイズイベントに紐付け
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll, { passive: true });
    
    // 初期状態の判定を実行
    this.onScroll();
  }

  onScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;
    const showThreshold = windowHeight * 0.5;
    const scrollDistance = 150; // スクロール量150pxかけて表示する

    // 1. スクロールに合わせて下から表示
    if (scrollY <= showThreshold) {
      // 完全に隠す（画面下150pxに配置）
      this.pageTop.style.transform = `translateY(150px)`;
      this.pageTop.style.opacity = '0';
      this.pageTop.style.visibility = 'hidden';
    } else if (scrollY > showThreshold && scrollY < showThreshold + scrollDistance) {
      // スクロール量に比例してY座標を計算（150px → 0pxへ）
      const progress = (scrollY - showThreshold) / scrollDistance;
      const y = 150 - (150 * progress);
      this.pageTop.style.transform = `translateY(${y}px)`;
      this.pageTop.style.opacity = '1';
      this.pageTop.style.visibility = 'visible';
    } else {
      // 完全に表示
      this.pageTop.style.transform = `translateY(0px)`;
      this.pageTop.style.opacity = '1';
      this.pageTop.style.visibility = 'visible';
    }

    // 2. フッターの位置に来たら上で止める（fixed -> absolute）
    if (this.footer) {
      const footerRect = this.footer.getBoundingClientRect();
      if (footerRect.top <= windowHeight) {
        this.pageTop.classList.add("-stop");
      } else {
        this.pageTop.classList.remove("-stop");
      }
    }
  }
}
